import React from 'react';
import { formatTextFloat, formatPercent } from '../../../../helpers/Text';
import './popup.scss';
import { Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { REDUCER_NAME } from './../../reducer';
import InputError from '../common/InputError';

const error = {
  inputCharacter: 'Only input number',
  notBlank: 'Not blank',
};

class PopupCostOfEquity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      average: null,
      listDataCheckbox: [],

      riskFreeRate: 4.77,
      vnIndexERP: 10.96,
      equityBOS: 1.1,
      otherAdjustment: 0,
      estimatedCOE: '',
      costOfEquity: '',
      estimatedCOEFormat: '',
      costOfEquityFormat: '',

      riskFreeRateValidate: true,
      vnIndexERPValidate: true,
      otherAdjustmentValidate: true,
      riskFreeRateError: '',
      vnIndexErpError: '',
      otherAdjustmentError: '',
    };
    this.riskFreeRate = React.createRef();
    this.vnIndexERP = React.createRef();
    this.equityBOS = React.createRef();
    this.otherAdjustment = React.createRef();
  }

  componentDidMount() {
    const { valuationStock } = this.props;
    this.setState(
      {
        riskFreeRate: parseFloat(
          formatTextFloat(formatPercent(valuationStock.riskFreeRate)),
        ),
        vnIndexERP: parseFloat(
          formatTextFloat(formatPercent(valuationStock.vnIndexEquityRisk)),
        ),
        equityBOS: valuationStock.rtd35
          ? parseFloat(formatTextFloat(valuationStock.rtd35))
          : 0,
      },
      this.caculateEstimatedCOE,
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { riskFreeRate, vnIndexERP, otherAdjustment } = this.state;

    if (
      riskFreeRate !== prevState.riskFreeRate ||
      vnIndexERP !== prevState.vnIndexERP ||
      otherAdjustment !== prevState.otherAdjustment
    ) {
      this.caculateEstimatedCOE();
    }
  }

  handleClickDone = () => {
    const { finishCaculate } = this.props;
    const { costOfEquity } = this.state;
    finishCaculate(costOfEquity);
  };

  handleInput = (e, refInput) => {
    const text = e.target.value;

    if (text.length > 0) {
      if (!text.match(/^[+-]?([0-9]+[.])?[0-9]+$/)) {
        if (refInput === this.riskFreeRate) {
          this.setState({
            ...this.state,
            riskFreeRateValidate: false,
            riskFreeRateError: error.inputCharacter,
            riskFreeRate: e.target.value,
          });
        }

        if (refInput === this.vnIndexERP) {
          this.setState({
            ...this.state,
            vnIndexERPValidate: false,
            vnIndexErpError: error.inputCharacter,
            vnIndexERP: e.target.value,
          });
        }

        if (refInput === this.otherAdjustment) {
          this.setState({
            ...this.state,
            otherAdjustmentValidate: false,
            otherAdjustmentError: error.inputCharacter,
            otherAdjustment: e.target.value,
          });
        }
        return;
      }
    } else {
      if (refInput === this.riskFreeRate) {
        this.setState({
          ...this.state,
          riskFreeRateValidate: false,
          riskFreeRateError: error.notBlank,
          riskFreeRate: e.target.value,
        });
      }

      if (refInput === this.vnIndexERP) {
        this.setState({
          ...this.state,
          vnIndexERPValidate: false,
          vnIndexErpError: error.notBlank,
          vnIndexERP: e.target.value,
        });
      }

      if (refInput === this.otherAdjustment) {
        this.setState({
          ...this.state,
          otherAdjustment: e.target.value,
        });
      }
      return;
    }

    if (e.target.value.length > 8) {
      return;
    }

    if (refInput === this.riskFreeRate) {
      this.setState({
        riskFreeRateValidate: true,
        riskFreeRateError: '',
        riskFreeRate: e.target.value,
        //estimatedCOE: this.caculateResultCoe(),
      });
    }
    if (refInput === this.vnIndexERP) {
      this.setState({
        vnIndexERPValidate: true,
        vnIndexErpError: '',
        vnIndexERP: e.target.value,
      });
    }
    if (refInput === this.otherAdjustment) {
      this.setState({
        otherAdjustmentValidate: true,
        otherAdjustmentError: '',
        otherAdjustment: e.target.value,
      });
    }
  };

  renderWrapTitleButtonPopup = () => {
    const { riskFreeRateValidate, vnIndexERPValidate } = this.state;
    return (
      <div className="popup-title-valuation-tool" style={{ clear: 'both' }}>
        <a style={{ float: 'left', marginTop: 5, fontWeight: 600 }}>
          <Translate value="valuation.popupFCFE.title" />
        </a>
        <button
          className="popup-button-valuation-tool"
          style={{
            float: 'right',
            marginTop: 5,
            marginRight: 5,
            cursor:
              !riskFreeRateValidate || !vnIndexERPValidate
                ? 'not-allowed'
                : 'pointer',
            background:
              !riskFreeRateValidate || !vnIndexERPValidate ? 'gray' : '#2d84a8',
          }}
          onClick={this.handleClickDone}
          disabled={!riskFreeRateValidate || !vnIndexERPValidate}
        >
          <Translate value="valuation.popupFCFE.button" />
        </button>
      </div>
    );
  };

  specialRowPopup = (
    firstTitle,
    refInput,
    value,
    noteField,
    isEnableModify,
    validate,
    errorTooltip,
    isValidateDisable,
  ) => {
    return (
      <div className="chirdren-row">
        <span className="first-span">
          <Translate value={firstTitle} />
        </span>
        {isEnableModify ? (
          <>
            <div className="wrap-input-error">
              <input
                className="input-method"
                type="text"
                ref={refInput}
                value={value}
                onChange={e => this.handleInput(e, refInput)}
                disabled={isValidateDisable}
              />
              {validate || <InputError message={errorTooltip} />}
            </div>
            <i
              className="icon-edit2 margin-icon"
              onClick={() => refInput.current.select()}
            />
            <span className="span-percen">{` % `}</span>
          </>
        ) : (
          <>
            <input
              className="input-method"
              type="text"
              value={value}
              disabled
            />
            <span
              className="span-percen"
              style={{ marginRight: 25 }}
            >{` % `}</span>
          </>
        )}
        <span style={{}}>
          <Translate value={noteField === null ? '' : noteField} />
        </span>
      </div>
    );
  };

  renderBody = () => {
    const {
      riskFreeRate,
      vnIndexERP,
      equityBOS,
      otherAdjustment,
      riskFreeRateValidate,
      vnIndexERPValidate,
      otherAdjustmentValidate,
      riskFreeRateError,
      vnIndexErpError,
      otherAdjustmentError,
      // estimatedCOE,
      // costOfEquity,
      estimateCOEFormat,
      costOfEquityFormat,
    } = this.state;

    // validate,
    // errorTooltip,
    // isValidateDisable

    return (
      <div className="body-fcfe">
        {this.specialRowPopup(
          'valuation.popupFCFE.riskFreeRate',
          this.riskFreeRate,
          riskFreeRate,
          'valuation.popupFCFE.riskFreeRateNote',
          true,
          riskFreeRateValidate,
          riskFreeRateError,
          !vnIndexERPValidate || !otherAdjustmentValidate ? true : false,
        )}

        {this.specialRowPopup(
          'valuation.popupFCFE.vnIndexERP',
          this.vnIndexERP,
          vnIndexERP,
          'valuation.popupFCFE.vnIndexErpNote',
          true,
          vnIndexERPValidate,
          vnIndexErpError,
          !riskFreeRateValidate || !otherAdjustmentValidate ? true : false,
        )}

        <div className="chirdren-row">
          <span className="first-span">
            <Translate value={'valuation.popupFCFE.equityBOS'} />
          </span>
          <input
            className="input-method"
            type="text"
            value={equityBOS}
            ref={this.equityBOS}
            disabled
          />
        </div>

        {this.specialRowPopup(
          'valuation.popupFCFE.estimatedCOE',
          null,
          estimateCOEFormat ? estimateCOEFormat : '',
          'valuation.popupFCFE.estimatedCoeNote',
          false,
        )}

        {this.specialRowPopup(
          'valuation.popupFCFE.otherAdjustment',
          this.otherAdjustment,
          otherAdjustment,
          null,
          true,
          otherAdjustmentValidate,
          otherAdjustmentError,
          !riskFreeRateValidate || !vnIndexERPValidate ? true : false,
        )}

        {this.specialRowPopup(
          'valuation.popupFCFE.costOfEquity',
          null,
          costOfEquityFormat ? costOfEquityFormat : '',
          null,
          false,
        )}
      </div>
    );
  };

  caculateEstimatedCOE = () => {
    const {
      riskFreeRate,
      vnIndexERP,
      equityBOS,
      otherAdjustment,
      riskFreeRateValidate,
      vnIndexERPValidate,
      otherAdjustmentValidate,
    } = this.state;
    if (riskFreeRateValidate && vnIndexERPValidate && otherAdjustmentValidate) {
      let estimatedCOE = +riskFreeRate + +equityBOS * +vnIndexERP;
      let costOfEquity = estimatedCOE + +otherAdjustment;
      this.setState({
        ...this.state,
        estimatedCOE: estimatedCOE ? estimatedCOE : null,
        costOfEquity: costOfEquity ? costOfEquity : null,
        estimateCOEFormat: estimatedCOE ? formatTextFloat(estimatedCOE) : null,
        costOfEquityFormat: costOfEquity ? formatTextFloat(costOfEquity) : null,
      });
    }
  };

  render() {
    return (
      <div>
        <div
          className={`popup-valuation-tool-fcfe`}
          style={{
            display: 'block',
            marginTop: -15,
            marginLeft: 30,
          }}
        >
          {this.renderWrapTitleButtonPopup()}
          {this.renderBody()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    valuationStock: state[REDUCER_NAME].valuationStock,
  };
};

export default connect(mapStateToProps)(PopupCostOfEquity);
